module.exports = __webpack_public_path__ + "static/media/background.42f35153.jpg";